/**
 * Encodes a given value using URI encoding and replaces single quotes with `%27`
 * @param value The value to encode
 * @returns The encoded value with single quotes replaced
 */
export function createURI(value: string) {
  return encodeURIComponent(value).replace(/'/g, "%27");
}
